import { call, put, takeEvery } from 'redux-saga/effects';
import { ActionType, getType } from 'typesafe-actions';
import { errorActions } from '../actions/error.actions';
import { changeSubscriptionActions } from '../actions/change-subscription.actions';
import { billingService } from '../services/billing.service';

function* watchSaveSubscription(action: ActionType<typeof changeSubscriptionActions.saveSubscription>) {
    yield put(changeSubscriptionActions.setSubscriptionSavingFlag(true));

    const { companyId, subscriptionType, subscriptionExpiration, isTrial = false } = action.payload;

    try {
        yield call(billingService.saveSubscription, companyId, subscriptionType, isTrial, subscriptionExpiration);
        yield put(changeSubscriptionActions.hide());
    } catch (e) {
        yield put(errorActions.unexpectedError(e));
    } finally {
        yield put(changeSubscriptionActions.setSubscriptionSavingFlag(false));
    }
}

export function* watchChangeSubscription() {
    yield takeEvery(getType(changeSubscriptionActions.saveSubscription), watchSaveSubscription);
}
